import { msg } from '@lingui/core/macro';
import { createSlice } from '@reduxjs/toolkit';

import { Plan } from '../domain/interfaces/plan';
import { createGivePlanReducer, createTopupBalanceReducer } from './reducers';

/**
 * Слайс держит статичный список тарифов и флаги операций биллинга.
 * Всё серверное читается через RTK Query: список организаций и карточка одной —
 * `store/organizers-api.ts`, активный тариф — `organizer/store/organizer-plan-api.ts`.
 */
export type OrganizersSliceState = {
  plans: {
    list: Plan[];
  };

  isProcessing: boolean;
  isProcessed: boolean;
  processName?: string;
};

const initialState: OrganizersSliceState = {
  plans: {
    list: [
      // Подписи — дескрипторы `msg`, а не строки: переводятся в `plans-block` на языке рендера.
      {
        id: 0,
        name: msg`Бесплатный`,
        price: 0,
      },
      {
        id: -1,
        name: msg`Базовый`,
        price: 1500,
      },
      {
        id: -2,
        name: msg`Продвинутый`,
        price: 2500,
      },
      {
        id: 2,
        name: msg`Профессиональный`,
        price: 10000,
      },
    ],
  },

  isProcessing: false,
  isProcessed: false,
};

const slice = createSlice({
  name: 'organizers',
  initialState,
  extraReducers: (builder) => {
    createTopupBalanceReducer(builder);
    createGivePlanReducer(builder);
  },
  reducers: {},
});

const organizersReducer = slice.reducer;
export default organizersReducer;
